
export default {
    // 协议组信息
    getProtGroupList(params, response) {
        window.vue.$apiAxios.get('/devCtlProt/getProtGroupList', params, response);
    },
    // 文件压缩
    compressFile(params, response) {
        window.vue.$apiAxios.get('/devCtlProt/compressFile', params, response);
    },
    // 文件下载
    exportFile(params, responseType, response) {
        window.vue.$apiAxios.download('/devCtlProt/exportFile', params, responseType, response);
    },
    // 协议调试接口
    protTestMethod(params, response) {
        window.vue.$apiAxios.postRequestBody('/devCtlProt/protTestMethod', params, response);
    },
    // 协议调试订阅接口
    mqSubscribe(params, response) {
        window.vue.$apiAxios.postRequestBody('/devCtlProt/subscribe', params, response);
    },
    // 协议信息
    queryProtList(params, response) {
        window.vue.$apiAxios.get('/devCtlProt/queryProtList', params, response);
    },
    // 删除文件
    deleteFile(params, response) {
        window.vue.$apiAxios.postRequestBody('/devCtlProt/deleteFile', params, response);
    }
};
